'use client';
import Image, { StaticImageData } from "next/image";
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'

import img2 from '@img/ourphotos/IMG_0002.jpg'
import img3 from '@img/ourphotos/IMG_0003.jpg'
import img4 from '@img/ourphotos/IMG_0004.jpg'
import img5 from '@img/ourphotos/IMG_0008.jpg'
import img6 from '@img/ourphotos/IMG_0009.jpg'
import img7 from '@img/ourphotos/IMG_0016.jpg'
import img8 from '@img/ourphotos/IMG_0017.jpg'
import img9 from '@img/ourphotos/IMG_0018.jpg'
import img10 from '@img/ourphotos/IMG_0019.jpg'
import img11 from '@img/ourphotos/IMG_0020.jpg'
import img12 from '@img/ourphotos/IMG_0021.jpg'
import img13 from '@img/ourphotos/IMG_0022.jpg'
import img14 from '@img/ourphotos/IMG_0025.jpg'
import img15 from '@img/ourphotos/IMG_0026.jpg'
import img16 from '@img/ourphotos/IMG_0027.jpg'
import img17 from '@img/ourphotos/IMG_0028.jpg'
import img23 from '@img/ourphotos/IMG_0032.jpg'
import img18 from '@img/ourphotos/IMG_9984.jpg'
import img19 from '@img/ourphotos/IMG_9994.jpg'
import img20 from '@img/ourphotos/IMG_9995.jpg'
import img21 from '@img/ourphotos/IMG_9998.jpg'
import img22 from '@img/ourphotos/IMG_9999.jpg'
import img24 from '@img/ourphotos/IMG__0072.jpg'
import img25 from '@img/ourphotos/IMG_0049.jpg'
import img26 from '@img/ourphotos/IMG_33.jpg'
import { useState } from "react";
import Link from "next/link";

export default function PhotosPage() {
    const images: StaticImageData[] = [
        img2, img19, img4, img20, img7, img6, img8, img9, img10, img11, img3, img12, img13, img14, img5, img15, img16, img17, img21, img18, img22, img23, img24, img25
    ]

    const firstColumn = images.filter((_, index) => index % 3 === 0);
    const secondColumn = images.filter((_, index) => index % 3 === 1);
    const thirdColumn = [...images.filter((_, index) => index % 3 === 2), img26];

    return <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

        <div className="mb-8 pb-8">
            {firstColumn.map((img) => (
                <ImageWrapper key={img.src} image={img} />
            ))}
        </div>
        <div className="mb-8 pb-8">
            {secondColumn.map((img) => (
                <ImageWrapper key={img.src} image={img} />
            ))}
        </div>
        <div className="mb-8 pb-8">
            {thirdColumn.map((img) => (
                <ImageWrapper key={img.src} image={img} />
            ))}
        </div>
        <div className="col-span-3">
            <div className="text-center text-gray-500 pt-2">
                Photography by <Link href="https://www.studiozwerveling.com/" target="_blank">Studio Zwerveling</Link>
            </div>
            <div className="text-center text-gray-500 pb-2">
                Florals by <Link href="https://www.nikosflowerdesigns.com/" target="_blank">Niko&apos;s Flower Design</Link>
            </div>
        </div>
    </div>;
};

function ImageWrapper({ image }: { image: StaticImageData }) {
    const [open, setOpen] = useState(false);
    const isHorizontal = image.width > image.height ? 'sm:max-w-4xl' : 'sm:max-w-2xl'
    return (
        <>
            <Dialog open={open} onClose={setOpen} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200 data-enter:ease-out data-leave:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={"relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200 data-enter:ease-out data-leave:ease-in sm:my-8 sm:w-full " + isHorizontal + " sm:max-h-dvh sm:p-6 sm:data-closed:translate-y-0 sm:data-closed:scale-95"}
                        >
                            <div>
                                <Image alt="" src={image} className="rounded-lg" />
                            </div>
                            <div className="mt-5 sm:mt-6">
                                <button
                                    type="button"
                                    onClick={() => setOpen(false)}
                                    className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Go back
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog >
            <Image alt="" src={image} className="w-full h-auto cursor-pointer hover:blur-xs rounded-sm my-4" sizes="100vw" placeholder="blur" onClick={() => { setOpen(true) }} />
        </>

    )
}